import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';

function RoundFinishButton(props) {
    const [disabled, setDisabled] = useState(null);

    // 初期状態およびround変更時の再評価
    useEffect(() => {
        if (props.round.endtime === null) {
            setDisabled(true);
            return;
        }
        const starttime = props.round.starttime ? new Date(props.round.starttime) : null;
        const now = new Date();
        if (props.event?.bet_close_mode === 'manual') {
            setDisabled(
                !starttime ||
                Number.isNaN(starttime.getTime()) ||
                now < starttime
            );
            return;
        }

        const endtime = new Date(props.round.endtime);
        setDisabled(endtime >= now);
    }, [props.event?.bet_close_mode, props.round, props.resetDisabledKey]);

    const handleFinishClick = () => {
        setDisabled(true); // 押下直後に即座に無効化
        if (props.round.result !== null && props.round.result !== undefined) {
            props.updateConfirmRoundResultDialogVisible(true);
        } else {
            props.updateSaveRoundResultDialogVisible(true);
        }
    };

    if (disabled === null) return null; // shouldDisable完了まで描画しない
    return (
        <Button
            variant="contained"
            color="primary"
            onClick={handleFinishClick}
            disabled={disabled}
        >
            {props.round.result !== null && props.round.result !== undefined ? '結果確認' : '結果登録'}
        </Button>
    );
}


export default RoundFinishButton;
